// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-warning {
    background: var(--survey-warning-background-color); /* light: ce-red-4 */
    color: var(--survey-validation-error-color); /* light: ce-red-55 */
    border-top: 1px solid var(--survey-warning-border-color); /* light: ce-red-20 */
    display: flex;
    flex-direction: row;
    font-size: 17px;
    padding: 1em 1.5em;
    line-height: 1.3;
    gap: 1em;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    box-sizing: border-box;
}

.project-warning .close-button {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/ProjectWarning.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD,EAAE,oBAAoB;IACxE,2CAA2C,EAAE,qBAAqB;IAClE,wDAAwD,EAAE,qBAAqB;IAC/E,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,OAAO;IACP,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".project-warning {\n    background: var(--survey-warning-background-color); /* light: ce-red-4 */\n    color: var(--survey-validation-error-color); /* light: ce-red-55 */\n    border-top: 1px solid var(--survey-warning-border-color); /* light: ce-red-20 */\n    display: flex;\n    flex-direction: row;\n    font-size: 17px;\n    padding: 1em 1.5em;\n    line-height: 1.3;\n    gap: 1em;\n    align-items: center;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 10000;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.project-warning .close-button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    cursor: pointer;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
